export default __webpack_public_path__ + "static/media/Pressure_UID_ti40037.d4f7a119.png";